import _api from '../_api';
import Franchise from '../../../models/Franchise';
import { titleCase, } from 'title-case';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    franchises: [],
    reports: [],
    managers: [],
    banks: [],
    marketplace_franchises: [],
    pageCount: 0,
    totalCount: 0,
    reportsPageCount: 15,
    isLoading: false,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.franchises,
    reports: (state,) => state.reports,
    managers: (state,) => state.managers,
    banks: (state,) => state.banks,
    filteredReports: (state,) => (filters,) => state.reports.filter((item,) => {
      let confirmation = true;
      Object.entries(filters,).forEach((filter,) => {
        if (filter[1]) {
          if (typeof filter[1] === 'string') {
            confirmation = item[filter[0]].
              toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0;
          } else {
            confirmation = item[filter[0]] === filter[1];
          }
        }
      },);
      return confirmation;
    },),
    marketplaceFranchises: (state,) => state.marketplace_franchises,
    reportsPageCount: (state,) => state.reportsPageCount,
    reportsTotalCount: (state,) => state.reportsTotalCount,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    isLoading: (state,) => state.isLoading,
  },
  // -----------------------------------------------------------------
  mutations: {
    setFranchises: (state, franchises,) => (state.franchises = franchises),
    setManagers: (state, managers,) => (state.managers = managers),
    setBanks: (state, banks,) => (state.banks = banks),
    setMarketplaceFranchises: (state, marketplaceFranchises,) =>
      (state.marketplace_franchises = marketplaceFranchises),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setFranchiseReports: (state, reports,) => (state.reports = reports),
    setReportsPageCount: (state, reportsPageCount,) =>
      (state.reportsPageCount = reportsPageCount),
    setReportsTotalCount: (state, reportsTotalCount,) =>
      (state.reportsTotalCount = reportsTotalCount),
    setLoading: (state, isLoading,) => 
      (state.isLoading = isLoading),
  },
  // -----------------------------------------------------------------
  actions: {
    /**
      * @deprecated Since new franchise list feature. Use getAll instead.
    */
    get: (
      { commit, },
      { page, name, operation_stage, mode, state, published, sort, sortBy, },
    ) => {
      commit('franchises/setFranchises', [], { root: true, },);

      return _api.get(
        { page, name, operation_stage, mode, state, published, sort, sortBy, },
      ).then(
        (response,) => {
          const franchises = response.
            data.items.map((franchise,) => new Franchise(franchise,),);
          commit('franchises/setFranchises', franchises, { root: true, },);
          commit(
            'franchises/setPageCount',
            Math.ceil(response.data.total_count / 15,),
            { root: true, },
          );
          commit('franchises/setTotalCount', response.data.total_count, {
            root: true,
          },);

          return franchises;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getAll: (
      { commit, },
      filters,
    ) => {

      commit('franchises/setFranchises', [], { root: true, },);
      commit('franchises/setLoading', true, { root: true, },);

      return _api.getAll(filters,).then((response,) => {

        const franchises = response.data.items.map((franchise,) => {
          return new Franchise(franchise,);
        },);

        commit('franchises/setFranchises', 
          {
            ...response.data,
            items: franchises,            
          },
          {
            root: true, 
          },
        );

        commit('franchises/setPageCount',
          Math.ceil(response.data.total_count / 15,),
          { 
            root: true,
          },
        );

        commit('franchises/setTotalCount',
          response.data.total_count,
          {
            root: true,
          },
        );

        commit('franchises/setLoading', false, { root: true, },);

        return {
          ...response.data,
          items: franchises,
        };
        
      },
      (error,) => {
        commit('franchises/setLoading', false, { root: true, },);
        return _api.handleError(error,);
      },);

    },
    getManagers: ({ commit, },) => {
      commit('franchises/setManagers', [], { root: true, },);

      return _api.getManagers().then(
        (response,) => {
          commit('franchises/setManagers', response.data, { root: true, },);
          return response;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getCities: (_, { franchises, page, search, size, from, },) => {
      return _api.getCities({ franchises, page, search, size, from, },).then(
        (response,) => {
          const data = response.data;
          data.cities = response.data.cities.map((city,) => ({
            id: String(city.id,),
            name: city.name,
            text: `${city.name} - ${city.state.acronym}`,
            checked: false,
            visible: false,
          }),);
          return data;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getBanks: ({ commit, },) => {
      commit('franchises/setBanks', [], { root: true, },);

      return _api.getBanks().then(
        (response,) => {
          commit('franchises/setBanks', response.map((bank,) => ({
            ...bank,
            text: titleCase(bank.text,),
          }),), { root: true, },);
          return response;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getMarketplaceFranchises: ({ commit, }, { cnpj, },) => {
      commit('franchises/setMarketplaceFranchises', [], { root: true, },);

      return _api.getMarketplaceFranchises({ cnpj, },).then(
        (response,) => {
          commit('franchises/setMarketplaceFranchises', response.data, { root: true, },);
          return response.data;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    create: async (_, value,) => {
      const newFranchise = new Franchise(value,).toPost;

      return new Promise((resolve, reject,) => {
        _api.
          post(newFranchise,).
          then((inserted,) => {

            resolve(inserted,);
          },).
          catch((error,) => {
            console.log('---------------',);

            console.log(error.response,);

            reject(error.response,);
          },);
      },);
    },
    operationEditFranchises: async (_, value,) => {
      return new Promise((resolve, reject,) => {
        _api.
          operationEditFranchises(value,).
          then((response,) => {

            resolve(response,);
          },).
          catch((error,) => {
            reject(error.response,);
          },);
      },);
    },
  },
};
